import { html, Page, View } from 'rune-ts';
import { BaseLayoutOptions } from '../../../features/Core/service';
import { staticTypo, typo } from '../../../shared/typography/typo';
import { getResizedImage100WebpUrl } from '../../../shared/util/getResizedImageUrl';
import { Alert } from '../../components/cells/Alert/Alert';
import { footer_links } from '../../components/cells/Footer/constant';
import klass from './Error.module.scss';
import { LayoutView } from '../../components/cells/Layout/LayoutView';

export type ErrorPageData = {
  is_mobile: boolean;
  status: 404 | 500;
  layout_options: BaseLayoutOptions;
  alert_msg?: string;
};

export type ErrorBodyViewData = {
  is_mobile: ErrorPageData['is_mobile'];
  status: ErrorPageData['status'];
  alert_msg?: ErrorPageData['alert_msg'];
};

export class ErrorBodyView extends View<ErrorBodyViewData> {
  protected override template() {
    const { img, title, description } = this.getData();

    return html`
      <div class="${klass.page}">
        <div class="${klass.status_container}">
          <div class="${klass.status} ${staticTypo('bebas_96_bold')}">${this.data.status}</div>
          <div class="${klass.image}">
            <img src="${img}" alt="error_img" />
          </div>
        </div>
        <div class="${klass.text}">
          <div class="${typo(this.data.is_mobile ? '20_bold' : '24_bold')}">${html.preventEscape(title)}</div>
          <div class="${klass.description} ${typo('16_medium')}">${html.preventEscape(description)}</div>
        </div>
      </div>
    `;
  }

  protected override onRender() {
    if (this.data.alert_msg) {
      return Alert.open({
        title: this.data.alert_msg,
      });
    }
  }

  getData = () => {
    if (this.data.status == 404)
      return {
        img: getResizedImage100WebpUrl(
          '//s3.marpple.co/files/u_2283830/2024/6/original/88a55aacfdc38ec99563e144c8e4f0218a458e462.png',
          1000,
        ),
        title: ET('mps2::error::404::title'),
        description: ET('mps2::error::404::description'),
      };
    return {
      img: getResizedImage100WebpUrl(
        '//s3.marpple.co/files/u_2283830/2024/6/original/1f622985d24c2075ec78ee078ffb287ec6e8d1df1.png',
        1000,
      ),
      title: ET('mps2::error::500::title'),
      description: ET('mps2::error::500::description'),
    };
  };
}

export class ErrorPage extends Page<ErrorPageData> {
  protected override template() {
    const { is_mobile, layout_options } = this.data;

    return html`
      <div>
        ${new LayoutView(
          {
            body: new ErrorBodyView(this.data),
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
